module.exports = __webpack_public_path__ + "img/ky2.04cef402.png";